// Action/Mutation types to be used from here for all modules.

// User
export const SET_USER = "SET_USER";
export const SET_ACCOUNT_DETAILS = "SET_ACCOUNT_DETAILS";
export const SET_USER_TOKEN = "SET_USER_TOKEN";

// Payment
export const SET_PAYMENT = "SET_PAYMENT";
